import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { convertTimeZoneDisplayText } from "ManagementTeam/utils/timezone";

export function getPdfFutureMeeting(meeting) {
  if (!meeting) return null;

  const dates =
    meeting.dates && meeting.dates.length > 0
      ? meeting.dates.map(
          (date) => new Date(date.startsOn.toLocaleString("en-US"))
        )
      : [];

  dayjs.extend(utc);
  const time =
    meeting.dates !== null &&
    meeting.dates !== undefined &&
    meeting.dates.length > 0
      ? `${dayjs
          .utc(meeting.dates[0].startsOn)
          .format("h:mm a")}. ${convertTimeZoneDisplayText(
          meeting.dates[0].timeZone
        )}`
      : "N/A";

  return {
    id: meeting._id,
    ifNeeded: meeting.ifNeeded,
    isCompleted: meeting.isComplete,
    checkIn: meeting.checkIn,
    datesAttendees:
      meeting.dates && meeting.dates.length > 0 ? meeting.dates : [],
    dates: dates,
    years:
      dates.length > 0
        ? dates.map((date) => String(date.getUTCFullYear()))
        : "",
    months:
      dates.length > 0
        ? dates.map((date) => date.toLocaleString("default", { month: "long" }))
        : "",
    month:
      dates.length > 0
        ? dates[0].toLocaleString("default", { month: "long" })
        : "",
    days:
      dates.length > 0 ? dates.map((date) => String(date.getUTCDate())) : "",
    state:
      meeting.inPerson && meeting.inPerson.state
        ? meeting.inPerson.state
        : null,
    city:
      meeting.inPerson && meeting.inPerson.city ? meeting.inPerson.city : null,
    location:
      meeting.inPerson && meeting.inPerson.location
        ? meeting.inPerson.location
        : null,
    time: time,
    deliveryType:
      meeting.deliveryType && meeting.deliveryType.length > 0
        ? meeting.deliveryType[0]
        : null,
    isInPerson: meeting.deliveryType.includes("In-person") ? true : false,
    isVirtual: meeting.deliveryType.includes("Virtual") ? true : false,
    isTextLight: false,
    virtual:
      meeting.virtual !== null && meeting.virtual !== undefined
        ? meeting.virtual
        : {
            zoomLink: "N/A",
            meetingId: "N/A",
            meetingPasscode: "N/A",
          },
  };
}
